module.exports = __webpack_public_path__ + "static/img/character-libra.baa844d6.png";